const SET_INFINITE_PAGE = 'scroll/infiniteGridScrollTop/SET_INFINTEPAGE'
const SET_TOP = 'scroll/infiniteGridScrollTop/SET'

export interface InfiniteGridScrollTop {
  isInfiniteGridPage: boolean
  scrollTop: boolean
}

const initialState: InfiniteGridScrollTop = {
  isInfiniteGridPage: false,
  scrollTop: false,
}

export const setInfinitePage = (isInfinitePage: boolean) => {
  return {
    isInfinitePage,
    type: SET_INFINITE_PAGE,
  }
}

export const setInfinitePageScrollTop = scrollTop => {
  return {
    scrollTop,
    type: SET_TOP,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INFINITE_PAGE:
      return {
        isInfiniteGridPage: action.isInfinitePage,
        scrollTop: false,
      }
    case SET_TOP:
      return {
        ...state,
        scrollTop: action.scrollTop,
      }
    default:
      return state
  }
}
